import React, { useState, Fragment } from "react";
// styles
import "./Subscription.scss";

//components
import Banner from "../../components/Banner/Banner";
import Card from "../../components/Card/Card";
import Modal from "react-modal";
import { useSubscriptionContext } from "../../context/providers/SubscriptionContext";
import Moment from "react-moment";
import History from "./History";
import CancelSubscription from "./CancelSubscription";
import RemoveCard from "./RemoveCard";
import CardModal from "./CardModal";
import { showErrorMessage, showSuccessMessage } from "../../utils/notification";
import Loader from "react-loader-spinner";
import moment from "moment";

const modalStylesReset = {
	overlay: {
		backgroundColor: "none",
	},
	content: {
		top: null,
		left: null,
		right: null,
		bottom: null,
		border: null,
		background: null,
		borderRadius: null,
		padding: null,
		position: null,
	},
};

Modal.setAppElement("#root");

export default function Subscription(props) {
	const userAuthenticated = JSON.parse(localStorage.getItem("user"));
	const {
		getSubscriptions,
		subscriptions,
		currentSubscription,
		checkSubscription,
		isValid,
		loading,
		error,
		clearNotification,
		success,
	} = useSubscriptionContext();
	const [activeModal, setActiveModal] = useState();

	const closeModal = () => {
		setActiveModal(0);
	};
	const checkAmount = (user) => {
		if (user.discount > 0) {
			return 16;
		} else {
			return 20;
		}
	};
	console.log(!userAuthenticated.subscriptionDeleted);

	React.useEffect(() => {
		if (success == null) {
			checkSubscription();
			getSubscriptions();
		}

		if (error !== null) {
			showErrorMessage(error);
			clearNotification();
		}
		if (success !== null) {
			showSuccessMessage(success);
			clearNotification();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [success, error]);

	return (
		<Fragment>
			<div className="container container--main container--limited_width">
				<Banner {...props}></Banner>

				<div
					className={`bank-card__container container--default mt-3 ${
						currentSubscription !== null && currentSubscription.transaction && currentSubscription.transaction.cardInfo
							? "d-md-flex flex-row-reverse"
							: ""
					}`}
				>
					{currentSubscription !== null && currentSubscription.transaction && currentSubscription.transaction.cardInfo && (
						<div className="d-flex flex-column justify-content-center pr-md-4">
							<Card data={currentSubscription.transaction.cardInfo} click={setActiveModal}></Card>
							<p className="fw--600 fz--14 mt-2 text-center">Tap on card to update</p>
						</div>
					)}

					<div
						className={`container--default mt-3 p-3 p-md-4 ${
							currentSubscription !== null && currentSubscription.transaction ? "" : "d-md-flex align-items-center"
						}`}
					>
						<div className={currentSubscription !== null && currentSubscription.transaction ? "" : "w-100 mr-md-4"}>
							<h2 className="container__title">Subscription</h2>
							{userAuthenticated.subscriptionDeleted ? (
								<Fragment>
									<p className="mt-3 color--accent fw--600">You have canceled your subscription</p>
									<p className="mt-2">You have access to materials until</p>
									<p className="mt-2 color--primary fw--700 fz--18">
										<Moment format="DD MMM, YYYY">{currentSubscription?.end}</Moment>
									</p>
								</Fragment>
							) : (
								<Fragment>
									<p className="mt-2">
										From{" "}
										<span className="color--primary fw--700 fz--18">
											<Moment format="DD MMM, YYYY">
												{currentSubscription !== null
													? currentSubscription.end
													: moment(userAuthenticated.trialStart).add(7, "days")}
											</Moment>
										</span>
									</p>
									<>
										<p className="mt-3 fw--600">
											We will charge you{" "}
											<span className="color--primary">
												{checkAmount(userAuthenticated)}{" "}
												$ 
											</span>
											. Please make sure your billing information is up to date.
										</p>
									</>
								</Fragment>
							)}
						</div>

						<div
							className={`d-flex flex-column align-items-center mt-4 ${
								isValid !== null  && currentSubscription !== null && currentSubscription.transaction ? "" : "w-100 ml-md-4"
							}`}
						>
							{isValid!==null && isValid 	 && currentSubscription !== null && currentSubscription.transaction && !userAuthenticated.subscriptionDeleted ? (
								<button className="btn btn--cancel w-100" onClick={() => setActiveModal("CancelSubscription")}>
									Unsubscribe
								</button>
							) : (
								<button
									className="btn btn--gradient w-100 justify-content-between"
									onClick={() => {
										setActiveModal("CardModal");
									}}
								>
									Buy subscription
									{userAuthenticated?.discount && userAuthenticated.discount > 0 ? (
										<span>
											<s className="opacity--05 pr-2">$20</s>
											$16
										</span>
									) : (
										<span>$20</span>
									)}
								</button>
							)}
							{userAuthenticated !== null && !userAuthenticated.subscriptionDeleted && userAuthenticated.discount > 0 && (
								<div className="fw--600 text-center">
									<p className="color--primary fz--18 mt-2">You have 20% discount</p>
									<p className="fz--14 mt-1">{userAuthenticated.discount} remaining</p>
								</div>
							)}
							{loading && (
								<div className="d-flex flex-column justify-content-center ">
									<div
										className="input__field mt-3 w-100 mt-md-4"
										style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
									>
										<Loader type="TailSpin" color="#3326ae" height={50} width={50} />
										<p className="input__label" style={{ marginLeft: "15px" }}>
											Please wait
										</p>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>

				{subscriptions !== null && <History subscriptions={subscriptions} loading={loading} />}
			</div>

			{userAuthenticated !== null && (
				<>
					<CardModal
						activeModal={activeModal}
						closeModal={closeModal}
						modalStylesReset={modalStylesReset}
						card={
							currentSubscription !== null &&
							currentSubscription.transaction &&
							currentSubscription.transaction.cardInfo
								? currentSubscription.transaction.cardInfo
								: null
						}
						user={userAuthenticated}
						setActiveModal={setActiveModal}
						isValid = {isValid}
						//method={getCard}
					/>

					<RemoveCard
						activeModal={activeModal}
						closeModal={closeModal}
						modalStylesReset={modalStylesReset}
						subscription={currentSubscription !== null ? currentSubscription : null}
						user={userAuthenticated}
					/>

					<CancelSubscription
						activeModal={activeModal}
						closeModal={closeModal}
						modalStylesReset={modalStylesReset}
						subscription={currentSubscription !== null ? currentSubscription : null}
						user={userAuthenticated}
					/>
				</>
			)}
		</Fragment>
	);
}
